import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Home, Wine, Map, Heart, User } from 'lucide-react';
import { ROUTES } from '@/lib/constants';

const navItems = [
  { href: ROUTES.home, label: 'Home', icon: Home },
  { href: ROUTES.farms, label: 'Farms', icon: Wine },
  { href: ROUTES.map, label: 'Map', icon: Map },
  { href: ROUTES.myLists, label: 'Lists', icon: Heart },
  { href: ROUTES.profile, label: 'Profile', icon: User },
];

export function BottomNav() {
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-sticky bg-white border-t border-neutral-200 safe-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.href;
          const Icon = item.icon;

          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                'flex flex-col items-center justify-center gap-1 flex-1 h-full transition-colors touch-target',
                isActive ? 'text-wine' : 'text-neutral-400'
              )}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
